<template>
  <el-card v-loading="loading" class="box-card summary-brand-container" ref="card">
    <div slot="header" class="clearfix header">
      <div class="header-title__outer">
        <div class="header-title">
          品牌投放 TOP100
          <el-tooltip class="item" effect="dark"
                      :content="`统计数据来源：${condition.year}年${condition.month}月内下单的订单。投放：含税收入。投放同比：去年同月含税收入对比。投放环比：上月含税收入对比。`"
                      placement="top-start">
          <span style="font-weight: lighter;font-size: 10px">
              （{{ condition.year }}年{{ condition.month }}月
            <i class="el-icon-info" style="cursor: pointer;color: #8a8e99"/>）
          </span>
          </el-tooltip>
          <div>
            <el-switch v-model="compare.bool" size="mini" style="margin-right: 4px;"/>
            <span :style="{cursor: 'pointer',color:compare.bool?'#ff3176':'#999'}">对比月</span>
          </div>
        </div>
        <div>
          <el-link style="float: right; padding: 3px 0;margin-left: 10px" type="primary" :underline="false"
                   title="点击刷新" @click="getData">
            <i class="el-icon-refresh-right"/>
          </el-link>
          <el-button style="float: right; margin-left: 10px;" size="mini" type="primary" plain icon="el-icon-upload2"
                     @click="$refs.feishuSyncDialog.open('brand_top')" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
          <summary-export-link style="float: right" filename="品牌投放TOP100"
                               :params="{...{tag: 'brand'},...condition}" :before="handleSearchCondition"/>
        </div>
      </div>
      <div v-if="compare.bool" class="header-compare-month">
        <div class="months">
          对比月份：
          <span v-for="(c_month,c_month_i) in compare.months" :key="c_month_i">
            {{ c_month }}
            <i v-if="c_month.trim()!==condition_y_m.trim()" class="el-icon-close"
               @click="handelDelMonth(c_month_i)"/>
          </span>
        </div>
        <el-popover placement="left" title="添加对比月份" width="200" trigger="click">
          <div style="text-align: center;margin-top: 20px;">
            <el-date-picker v-model="compare.month" type="month" size="mini" placeholder="选择月"
                            value-format="yyyy年MM月"
                            style="width: 200px;"/>
            <div style="text-align: right; margin-top: 20px;">
              <el-button type="primary" size="mini" @click="handleAppendMonth">确定</el-button>
            </div>
          </div>
          <el-button slot="reference" type="primary" round size="mini"><i class="el-icon-plus"/> 添加月份</el-button>
        </el-popover>
      </div>

    </div>
    <el-table :key="key" v-if="compare.bool" v-loading="compare.loading" :data="compare.table" class="dashboard-table">
      <el-table-column label="品牌" align="center" width="70" show-overflow-tooltip>
        <template v-slot="{row:{brand_name}}">
          <div style="border-right: 1px solid #EBEEF5;">
            {{ brand_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column>
        <template v-slot="{row:{children}}">
          <el-table :data="children" :border="false" class="dashboard-table brand_compare-table">
            <el-table-column prop="the" label="月份" align="center"/>
            <el-table-column prop="order_money" label="投放" align="center">
              <template v-slot="{row:{order_money}}">
                ￥{{ order_money|numberFormat(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="yoy" label="同比" align="center">
              <template v-slot="{row:{yoy}}">
                <span v-if="yoy>0" style="color: rgb(255, 51, 51)">+{{ yoy|numberFormat(2) }}%</span>
                <span v-else-if="yoy<0" style="color: rgb(57, 179, 98)">{{ yoy|numberFormat(2) }}%</span>
                <span v-else style="color:rgb(57, 179, 98)">0%</span>
              </template>
            </el-table-column>
            <el-table-column prop="mom" label="环比" align="center">
              <template v-slot="{row:{mom}}">
                <span v-if="mom>0" style="color: rgb(255, 51, 51)">+{{ mom|numberFormat(2) }}%</span>
                <span v-else-if="mom<0" style="color: rgb(57, 179, 98)">{{ mom|numberFormat(2) }}%</span>
                <span v-else style="color: rgb(57, 179, 98)">0%</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-else class="dashboard-table"
              show-summary
              :key="key+'n'"
              :summary-method="getSummaries"
              :data="data"
              :row-style="{ border: 'none',padding:'15px 0'}"
              :cell-style="{ border: 'none'}"
              @sort-change="sortChange"
              style="width: 100%" v-loading="loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading">
      <el-table-column prop="brand_name" label="品牌" align="center" min-width="120">
        <template slot-scope="scope">
          <div style="display: flex;">
            <div style="width: 30px;text-align: right;">
              <span v-if="scope.row.is_newer" class="newer">new</span>
            </div>
            <el-link type="primary" @click="toDetail(scope.row.brand_name)">
              <span style="font-size: 12px">{{ scope.row.brand_name }}</span>
            </el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="trade" label="行业" align="center" min-width="110" show-overflow-tooltip/>
      <el-table-column prop="order_money" label="投放" align="right" header-align="right" sortable="custom" min-width="110">
        <template slot-scope="scope">
          <span class="money">{{ scope.row.order_money|numberFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="投放同比" align="right" header-align="right" min-width="110">
        <template slot="header">
          <el-tooltip class="item" effect="dark"
                      :content="`投放同比：(本期投放 - 去年同期投放) ÷ 去年同期投放 × 100%`"
                      placement="top-start">
            <span>投放同比
              <i class="el-icon-info" style="cursor: pointer;color: #8a8e99"/>
            </span>
          </el-tooltip>
        </template>
        <template v-slot="{row:{yoy}}">
          <span v-if="yoy>0" style="color: rgb(255, 51, 51)">+{{ yoy|numberFormat(2) }}%</span>
          <span v-else-if="yoy<0" style="color: rgb(57, 179, 98)">{{ yoy|numberFormat(2) }}%</span>
          <span v-else style="color:rgb(57, 179, 98)">0%</span>
        </template>
      </el-table-column>
      <el-table-column label="投放环比" align="right" header-align="right" min-width="110">
        <template slot="header">
          <el-tooltip class="item" effect="dark"
                      :content="`投放环比：(本期投放 - 上期投放) ÷ 上期投放 × 100%`"
                      placement="top-start">
            <div>
               投放环比
              <i class="el-icon-info" style="cursor: pointer;color: #8a8e99"/>
            </div>
          </el-tooltip>
        </template>
        <template v-slot="{row:{mom}}">
          <span v-if="mom>0" style="color: rgb(255, 51, 51)">+{{ mom|numberFormat(2) }}%</span>
          <span v-else-if="mom<0" style="color: rgb(57, 179, 98)">{{ mom|numberFormat(2) }}%</span>
          <span v-else style="color: rgb(57, 179, 98)">0%</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_percent_money" :label="`投放占比`" align="right"
                       header-align="right" min-width="120">
        <template slot-scope="scope">
          <span class="rate">{{ gFunc.numberFormat(scope.row.order_percent_money, 1) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_count" label="订单数" align="right" header-align="right" sortable="custom"
                       min-width="80"/>
      <el-table-column prop="order_percent_count" :label="`订单数占比`" align="right"
                       header-align="right" min-width="120">
        <template slot-scope="scope">
          <span class="rate">{{ gFunc.numberFormat(scope.row.order_percent_count, 1) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <feishu-sync-dialog ref="feishuSyncDialog" :scopes="syncScopes" :condition="condition"/>
  </el-card>
</template>

<script>
import {getDashboardBrand} from "@/api/dashboard";
import {
  feishuBrandTopSyncConfig,
  saveFeishuBrandTopSyncConfig,
  feishuSyncBrandTop
} from "@/api/feishu";
import FeishuSyncDialog from "@/components/summary/FeishuSyncDialog.vue";
import SummaryExportLink from "@/components/summary/ExportLink.vue";
import moment from "moment";
import {getDashboardBrandCompare} from "../../api/dashboard";

const getKey = function () {
  return new Date().getTime() + ''
}

const format_y_m = "YYYY年M月"

// 「同步到飞书」维度配置（共用 FeishuSyncDialog）
const SYNC_SCOPES = {
  brand_top: {
    label: '品牌投放TOP100',
    entity: '品牌投放',
    rowHint: '每个品牌写入一条记录（含 Top100 之外合计行）',
    getConfig: feishuBrandTopSyncConfig,
    saveConfig: saveFeishuBrandTopSyncConfig,
    sync: feishuSyncBrandTop
  }
}

export default {
  name: "SummaryBrand",
  components: {SummaryExportLink, FeishuSyncDialog},
  inject: ['condition'],
  data() {
    return {
      // 同步到飞书：维度配置（共用 FeishuSyncDialog）
      syncScopes: SYNC_SCOPES,
      key: getKey(),
      switchCompareMonth: false,
      loading: false,
      queryOrder: '',
      queryProp: '',
      data: [],
      compare: { // 对比月份
        loading: false,
        bool: false,
        month: null,
        months: [],
        table: []
      }
    }
  },
  computed: {
    condition_y_m() {
      return ` ${this.condition.year}年${parseInt(this.condition.month + '')}月`
    }
  },
  created() {
    this.getData()
  },
  watch: {
    condition: {
      handler: function () {
        this.getData()
      },
      deep: true
    },
    "compare.bool"(_) {
      if (_) {
        this.compare.months = [`${this.condition_y_m}`]
        this.getCompareData()
      }
      this.key = getKey()
    }
  },
  methods: {
    handelDelMonth: function (c_month_i) {
      this.compare.months.splice(c_month_i, 1)
      this.getCompareData()
    },
    handleAppendMonth: function () {
      const array = [...[], ...this.compare.months]
      if (array.length > 4) {
        this.$message.warning('最多对比五个')
        document.body.click()
        return
      }
      array.push(this.compare.month)

      let tmp = array.map(function (e) {
        return moment(e, format_y_m).valueOf()
      })
      tmp = Array.from(new Set(tmp))
      tmp.sort(function (a, b) {
        return a < b ? 1 : -1
      });
      this.compare.months = tmp.map(function (e) {
        return moment(e).format(format_y_m)
      })
      document.body.click()
      // 触发刷新列表
      this.getCompareData()
    },
    getCompareData: async function () {
      const months = []
      const month_maps = []
      this.compare.months.map(function (e) {
        // 月份
        const tmp = moment(e, format_y_m)
        // 同比
        const tmp_yoy = moment(e, format_y_m).subtract(1, "years")
        // 环比
        const tmp_mom = moment(e, format_y_m).subtract(1, "months")
        months.push({year: tmp.format('YYYY'), month: tmp.format('MM'), y_m: tmp.format(format_y_m)})
        months.push({year: tmp_yoy.format('YYYY'), month: tmp_yoy.format('MM'), y_m: tmp_yoy.format(format_y_m)})
        months.push({year: tmp_mom.format('YYYY'), month: tmp_mom.format('MM'), y_m: tmp_mom.format(format_y_m)})

        month_maps.push({
          the: tmp.format(format_y_m),
          yoy: tmp_yoy.format(format_y_m),
          mom: tmp_mom.format(format_y_m),
        })
      })
      this.compare.loading = true
      const {model} = await getDashboardBrandCompare({
        months,
        month_maps,
        year: this.condition.year,
        month: this.condition.month
      })
      this.compare.loading = false
      this.compare.table = model || []
    },
    handleSearchCondition() {
      let params = {...{}, ...this.condition}
      params = {...params, ...{queryOrder: this.queryOrder, queryProp: this.queryProp}}

      // 同比月份
      const yoy = moment(this.condition_y_m, format_y_m).subtract(1, "years")
      // 环比月份
      const mom = moment(this.condition_y_m, format_y_m).subtract(1, "months")
      params.yoy_year = yoy.format('YYYY')
      params.yoy_month = yoy.format('MM')
      params.yoy_y_m = yoy.format(format_y_m)
      params.mom_year = mom.format('YYYY')
      params.mom_month = mom.format('MM')
      params.mom_y_m = mom.format(format_y_m)
      params.tag = 'brand'

      return params
    },
    getData() {
      this.getCompareData()

      this.loading = true;
      this.data = [];
      const searchCondition = this.handleSearchCondition()

      getDashboardBrand(searchCondition).then(res => {
        this.loading = false;
        this.data = res.model.data;
        this.$nextTick(() => {
          if (this.$refs.card) {
            const height = this.$refs.card.$el.offsetHeight;
            this.$emit('setSideHeight', height)
          }

        })
      })
    },
    sortChange({prop, order}) {
      this.queryOrder = order === "descending" ? 'desc' : 'asc'
      this.queryProp = prop
      this.getData()
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        if (['order_money', 'order_percent_money', 'order_count', 'order_percent_count'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "order_money":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index]);
              break;
            case "order_percent_money":
            case "order_percent_count":
              sums[index] = this.gFunc.numberFormat(sums[index]) + "%";
              break;
          }
        }
      });
      return sums
    },
    toDetail(brandName) {
      const {href} = this.$router.resolve({
        name: `homeBrandDetail`,
        query: {brandName: brandName, year: this.condition.year, organization_id: this.condition.organization_id}
      });
      window.open(href, "_blank");
    }
  }
}
</script>

<style lang="scss">
.summary-brand-container {

  .caret-wrapper {
    width: 8px !important;
  }

  .newer {
    width: 27px;
    height: 15px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(255, 87, 34);
    color: rgb(255, 255, 255);
    line-height: 0;
    float: right;
    margin-right: 6px;
  }

  .header {
    .header-title {
      display: flex;
      align-items: center;

      &__outer {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .header-compare-month {
      border-top: 1px solid #F2F2F2;
      padding-top: 12px;
      margin-top: 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .el-button--mini.is-round {
        padding: 4px 14px !important;
      }

      .months {
        span {
          line-height: 16px;
          height: 16px;
          padding: 4px 12px;
          background: #ffeef3;
          border-radius: 4px;
        }

        span + span {
          margin-left: 10px;
        }

        .el-icon-close {
          cursor: pointer;
        }
      }
    }
  }

  .brand_compare-table::before {
    display: none;
  }

  .brand_compare-table {
    .el-table__cell {
      border-bottom: 0 !important;
    }
  }
}
</style>
